import script from "./TwoFA.vue?vue&type=script&setup=true&lang=js"
export * from "./TwoFA.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__